import { Tooltip, TooltipProps } from '@mui/material';
import { InfoIcon } from '../Icons';

type AppInfoIconProps = {
  tooltipProps: Omit<TooltipProps, 'children'>;
  size?: number;
};

export const AppInfoIcon = ({ tooltipProps, size = 16 }: AppInfoIconProps) => (
  <Tooltip {...tooltipProps}>
    <InfoIcon width={size} height={size} />
  </Tooltip>
);
